<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="user-dashboard-info-box">
          <div class="section-title-02 mb-4">
            <h4>Change Password</h4>
          </div>
          <div class="row">
            <div class="col-12">
              <form [formGroup]="form">
                <div class="form-row" *ngIf="failedAuthentication">
                  <div class="form-group col-12">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      {{failedAuthenticationReason}}
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true" (click)="onDismissError()">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label>Current Password *</label>
                    <input type="password" class="form-control" formControlName="currentPassword">
                  </div>
                </div>
                <div class="form-row">
                  <div formGroupName="passwordGroup" class="form-group col-md-12">
                    <div class="col-md-12" style="float: left; padding-left: 0; padding-right: 5px;">
                      <label>New Password *</label>
                      <input type="password" formControlName="newPassword" placeholder="min 8 characters"
                        [class.is-valid]="!form.get('passwordGroup.newPassword')?.errors"
                        [class.is-invalid]="!form.pristine && form.get('passwordGroup.newPassword')?.errors"
                        class="form-control">
                      <password-strength-meter [password]="form.get('passwordGroup.newPassword').value"
                        minPasswordLength="8"></password-strength-meter>
                    </div>
                    <div class="col-md-12" style="float: left; padding-left: 0; padding-right: 5px;">
                      <label for="password2">Confirm Password *</label>
                      <input type="password" formControlName="confirmPassword"
                        [class.is-valid]="!form.get('passwordGroup.confirmPassword')?.pristine && !form.hasError('notSame', 'passwordGroup')"
                        [class.is-invalid]="!form.pristine && form.get('passwordGroup.confirmPassword')?.errors"
                        class="form-control">
                      <span *ngIf="form.hasError('notSame', 'passwordGroup')" style="color: red;">
                        Confirm password does not match to Password.
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <a class="btn btn-lg btn-primary" [routerLink]="" (click)="save()">Change Password</a>
      </div>
    </div>
  </div>
</section>

